// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__GXqmB","inner":"Notification_inner__xI78M","show":"Notification_show__nTikX","caution":"Notification_caution__oLF7z"};